import {
  Alignment,
  Button,
  IconName,
  Menu,
  MenuDivider,
  NavbarDivider,
  NavbarGroup,
} from "@blueprintjs/core";
import { MenuItem2, Popover2 } from "@blueprintjs/popover2";
import _ from "lodash";
import { useHistory } from "react-router-dom";

export interface IMenuItem {
  text?: string;
  to?: string;
  href?: string;
  divider?: boolean;
  children?: IMenuItem[];
  left_icon?: IconName;
  right_icon?: IconName;
}

interface RenderMenuItemProps {
  item: IMenuItem;
  is_root: boolean;
}

const BuildChildren = (items?: IMenuItem[], is_root: boolean = false) =>
  items
    ? _.map(items, (child) => (
        <RenderMenuItem
          key={child.text || child.to || child.href}
          item={child}
          is_root={is_root}
        />
      ))
    : undefined;

export const RenderMenuItem = ({ item, is_root }: RenderMenuItemProps) => {
  // const button = (
  //   <Button
  //     text={item.text}
  //     minimal
  //     rightIcon={
  //       item.right_icon
  //         ? item.right_icon
  //         : item.children
  //         ? "chevron-down"
  //         : undefined
  //     }
  //     icon={item.left_icon}
  //   />
  // );

  // const menu_item = (
  //   <MenuItem
  //     text={item.text}
  //     icon={item.left_icon}
  //     labelElement={
  //       item.right_icon ? <Icon icon={item.right_icon} /> : undefined
  //     }
  //     children={item.children ? BuildChildren(item.children, false) : undefined}
  //     style={{ listStyle: "none" }}
  //   />
  // );

  const history = useHistory();

  if (is_root) {
    const button = (
      <Button
        key={item.text}
        text={item.text}
        minimal
        rightIcon={
          item.right_icon
            ? item.right_icon
            : item.children
            ? "chevron-down"
            : undefined
        }
        icon={item.left_icon}
        onClick={(e) => {
          e.preventDefault();
          const href = item.href || item.to;
          if (href) history.push(href);
        }}
      />
    );

    if (item.children)
      return (
        <Popover2
          key={item.text + "_p2"}
          placement="bottom"
          interactionKind="click"
          content={<Menu children={BuildChildren(item.children)} />}
          children={button}
        />
      );
    else return button;
  }

  if (item.divider) return <MenuDivider />;

  return (
    <MenuItem2
      key={item.text}
      text={item.text}
      children={BuildChildren(item.children)}
      href={item.href || item.to}
      onClick={(e) => {
        e.preventDefault();
        const href = item.href || item.to;
        if (href) history.push(href);
      }}
      icon={item.left_icon}
    />
  );
};

export const NavbarMenu = (props: {
  items: IMenuItem[];
  children?: JSX.Element;
}) => (
  <NavbarGroup align={Alignment.LEFT}>
    {props.children ? props.children : <></>}
    <NavbarDivider />
    {BuildChildren(props.items, true)}
  </NavbarGroup>
);
